<template>
  <v-card flat width="100%">
    <v-card-title>Keywords</v-card-title>
    <v-card-text>
      <v-col cols="12">
        <select-keywords :clear="clear" v-model="keyword"></select-keywords>
        <v-chip
          @click:close="deleteKeyword(keyword)"
          class="mr-1"
          close
          v-for="keyword in data"
          :key="keyword"
          >{{ keyword }}</v-chip
        >
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectKeywords from './SelectKeywords.vue'
export default {
  props: {
    value: {
      default() {
        return []
      }
    }
  },
  components: {
    SelectKeywords
  },
  data() {
    return {
      keyword: '',
      data: [],
      clear: true
    }
  },
  watch: {
    keyword(value) {
      if (value) {
        if (!this.data.includes(value)) {
          this.data.push(value)
        }
        this.keyword = ''
        this.clear = !this.clear
      }
    },
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
      // this.items.push(value)
    }
  },
  methods: {
    deleteKeyword(keyword) {
      this.data = this.data.filter(i => i !== keyword)
    }
  }
}
</script>

<style></style>
